import { Box, Link, Text } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import type { AdmissionDeclarationDto } from "../../../../autogen/bff-api";
import { urls } from "../../../../urls";
import { displayDate } from "../../../../common/formatting/displayDate";

export const AdmissionDeclarationNotice = ({ admission }: { admission: AdmissionDeclarationDto }) => {
  const { t } = useTranslation();
  return (
    <Box borderWidth="1px" borderColor="smBorder" borderRadius="lg" p="5">
      <Text fontWeight="semibold" fontSize="sm">
        {t("The self-declaration was given at admission")}
      </Text>
      <Text fontSize="sm" color="smMuted" mt="1">
        {t(
          "The supplier declared the exclusion grounds when they were admitted to {{scheme}} on {{date}}, and every purchase under it runs on that declaration.",
          { scheme: admission.schemeTitle, date: displayDate(admission.submittedAt) },
        )}
      </Text>
      <Link
        as={RouterLink}
        to={urls.v2.sourcingEvents.participationRequestDetail.go(
          admission.schemeId,
          admission.participationRequestId,
        )}
        color="smPrimary"
        fontSize="sm"
        mt="3"
        display="inline-block"
      >
        {t("Open the admission")}
      </Link>
    </Box>
  );
};
